import { useEffect } from "react";

const DEFAULT_GA_ID = "G-511621392";
const GA_ID = process.env.REACT_APP_GA_MEASUREMENT_ID || DEFAULT_GA_ID;

const useAnalytics = () => {
  useEffect(() => {
    if (!GA_ID) {
      console.warn("Google Analytics ID not provided. Skipping GA initialization.");
      return;
    }

    const hostname = window.location.hostname;
    const isLocalhost =
      hostname === "localhost" ||
      hostname === "127.0.0.1" ||
      hostname.endsWith(".local");

    if (isLocalhost) {
      console.info("Running on localhost; Google Analytics tracking is disabled.");
      return;
    }

    const existingScript = document.querySelector(
      `script[src="https://www.googletagmanager.com/gtag/js?id=${GA_ID}"]`
    );
    if (existingScript) {
      return;
    }

    const script = document.createElement("script");
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;

    const inlineScript = document.createElement("script");
    inlineScript.innerHTML = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', '${GA_ID}');
    `;

    document.head.appendChild(script);
    document.head.appendChild(inlineScript);

    return () => {
      if (script.parentNode) {
        document.head.removeChild(script);
      }
      if (inlineScript.parentNode) {
        document.head.removeChild(inlineScript);
      }
    };
  }, []);
};

export default useAnalytics;

